module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings":"Settings","logout":"Logout","help":"Help","admin":"Organization Settings","loggedInAs":"You are logged in as {name}","impressumLink":"Legal","privacyLink":"Privacy"},"de":{"settings":"Einstellungen","logout":"Abmelden","help":"Hilfe","admin":"Administration","loggedInAs":"Du bist als {name} angemeldet","impressumLink":"Impressum","privacyLink":"Datenschutz"}}')
  delete Component.options._Ctor
}
